import React, { useCallback } from "react";
import { can } from "../features/auth/permissions";
import { RequireAccess } from "./RequireAccess";

/** Гард роута по матрице прав: `<RequirePermission resource="role">`. */
export function RequirePermission({ resource, action = "read", children, forbiddenTo = null }) {
  const isAllowed = useCallback((user) => can(user, resource, action), [resource, action]);
  return (
    <RequireAccess isAllowed={isAllowed} forbiddenTo={forbiddenTo}>
      {children}
    </RequireAccess>
  );
}
